import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Submit registration (final step)
export const submitRegistration = createAsyncThunk(
  'registration/submit',
  async (formData, thunkAPI) => {
    try {
      // Example: API call
      // const response = await api.post('/register', formData);
      return formData;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || 'Failed to register');
    }
  }
);

const initialState = {
  currentStep: 0,
  completed: [false, false, false, false, false],
  formData: {
    id: '',
    attributes: {
      inviteToken: '',
      firstName: '',
      lastName: '',
      stationGroupId: 0,
      phone: '',
      password: '',
      passwordRepeat: '',
      agree: false,
      // Add more fields here if needed in later steps
    }
  },
  submitting: false,
  error: null
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    changeFormStep: (state, action) => {
      const { step, completed } = action.payload;
      state.currentStep = step;
      if (typeof completed === 'boolean') {
        state.completed[step] = completed;
      }
    },
    updateFormData: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
        attributes: {
          ...state.formData.attributes,
          ...action.payload.attributes
        }
      };
    },
    resetRegistration: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitRegistration.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(submitRegistration.fulfilled, (state) => {
        state.submitting = false;
        state.completed = [true, true, true, true, true];
      })
      .addCase(submitRegistration.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      });
  }
});

export const { changeFormStep, updateFormData, resetRegistration } = registrationSlice.actions;

export default registrationSlice.reducer;
